import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './formContext';
import { TanstackFormAsyncMultiSelect } from './TanstackFormAsyncMultiSelect/TanstackFormAsyncMultiSelect';
import { TanstackFormAsyncSelect } from './TanstackFormAsyncSelect/TanstackFormAsyncSelect';
import { TanstackFormCheckbox } from './TanstackFormCheckbox/TanstackFormCheckbox';
import { TanstackFormColorPicker } from './TanstackFormColorPicker/TanstackFormColorPicker';
import { TanstackFormDatePicker } from './TanstackFormDatePicker/TanstackFormDatePicker';
import { TanstackFormDateRangePicker } from './TanstackFormDateRangePicker/TanstackFormDateRangePicker';
import { TanstackFormDateTimePicker } from './TanstackFormDateTimePicker/TanstackFormDateTimePicker';
import { TanstackFormDurationPicker } from './TanstackFormDurationPicker/TanstackFormDurationPicker';
import { TanstackFormImageUpload } from './TanstackFormImageUpload/TanstackFormImageUpload';
import { TanstackFormInput } from './TanstackFormInput/TanstackFormInput';
import { TanstackFormMultiSelect } from './TanstackFormMultiSelect/TanstackFormMultiSelect';
import { TanstackFormPhoneInput } from './TanstackFormPhoneInput/TanstackFormPhoneInput';
import { TanstackFormRadioGroup } from './TanstackFormRadioGroup/TanstackFormRadioGroup';
import { TanstackFormSelect } from './TanstackFormSelect/TanstackFormSelect';
import { TanstackFormSelectableBoxMultiSelect } from './TanstackFormSelectableBoxMultiSelect/TanstackFormSelectableBoxMultiSelect';
import { TanstackFormSwitch } from './TanstackFormSwitch/TanstackFormSwitch';
import { TanstackFormTextArea } from './TanstackFormTextArea/TanstackFormTextArea';
import { TanstackFormTime } from './TanstackFormTime/TanstackFormTime';
import { TanstackFormTimeRange } from './TanstackFormTimeRange/TanstackFormTimeRange';
import { TanstackFormTireDimensionInput } from './TanstackFormTireDimensionInput/TanstackFormTireDimensionInput';
import { TanstackSubscribeButton } from './TanstackSubscribeButton/TanstackSubscribeButton';

const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Input: TanstackFormInput,
    TextArea: TanstackFormTextArea,
    Checkbox: TanstackFormCheckbox,
    ColorPicker: TanstackFormColorPicker,
    Switch: TanstackFormSwitch,
    Select: TanstackFormSelect,
    AsyncSelect: TanstackFormAsyncSelect,
    MultiSelect: TanstackFormMultiSelect,
    AsyncMultiSelect: TanstackFormAsyncMultiSelect,
    SelectableBoxMultiSelect: TanstackFormSelectableBoxMultiSelect,
    RadioGroup: TanstackFormRadioGroup,
    PhoneInput: TanstackFormPhoneInput,
    DatePicker: TanstackFormDatePicker,
    DateRangePicker: TanstackFormDateRangePicker,
    DateTimePicker: TanstackFormDateTimePicker,
    DurationPicker: TanstackFormDurationPicker,
    ImageUpload: TanstackFormImageUpload,
    Time: TanstackFormTime,
    TimeRange: TanstackFormTimeRange,
    TireDimensionInput: TanstackFormTireDimensionInput
  },
  formComponents: {
    SubscribeButton: TanstackSubscribeButton
  }
});

export { useAppForm };
